export const COLORS = ['cyan', 'black'];
